import { atom } from 'recoil';

export const isDocumentAuthenticated = atom<boolean>({
  key: 'isDocumentAuthenticated',
  default: false,
});
